"use client";

import { CookieType } from "@/constants";

const readCookie = (name: string) =>
	document.cookie
		.split("; ")
		.find((c) => c.startsWith(`${name}=`))
		?.split("=")[1] ?? null;

/**
 * The CSRF cookie is minted by middleware.ts on GET requests and expires after
 * 30s, so it is often absent by the time a mutation fires. Ping /api/csrf to
 * make the middleware issue a fresh one, then read it back.
 */
export const getCsrfToken = async (): Promise<string | null> => {
	const existing = readCookie(CookieType.CSRF_TOKEN);
	if (existing) return decodeURIComponent(existing);

	await fetch("/api/csrf", { method: "GET", cache: "no-store" }).catch(
		() => {},
	);
	const minted = readCookie(CookieType.CSRF_TOKEN);
	return minted ? decodeURIComponent(minted) : null;
};
